export const DOCUMENT_TYPES = "/DocumentTypeDef/GetDocumentTypes"